import { useTheme } from '../../theme/ThemeContext';
import './BrandLogo.css';

const LOGOS = {
  light: `${process.env.PUBLIC_URL}/images/logolight.svg`,
  dark: `${process.env.PUBLIC_URL}/images/logodark.svg`,
};

export default function BrandLogo({ size = 'md' }) {
  const { theme } = useTheme();
  const src = LOGOS[theme] || LOGOS.light;

  return (
    <span className={`brand-logo brand-logo--${size}`}>
      <img className="brand-logo__img" src={src} alt="Logz" />
    </span>
  );
}
